import { Typography, theme } from "antd";
import {
  ColumnComponent,
  ContainerComponent,
  RowComponent,
} from "../../../components";

export const SuccessCasesPartial = ({ useCase }) => {
  const {
    token: {
      colorTextSecondary,
      colorAccent,
      colorTextInverse,
      colorBgLayout,
      colorTextHeading,
    },
  } = theme.useToken();
  return (
    <ColumnComponent
      style={{
        textAlign: "start",
        maxWidth: "30%",
      }}
    >
      <Typography.Title level={4} style={{}}>
        Casos de éxito
      </Typography.Title>
      <Typography.Text
        style={{
          textAlign: "start",
          color: colorTextSecondary,
        }}
      >
        Resultados obtenidos con la implementación de esta solución:
      </Typography.Text>

      <ContainerComponent
        style={{
          marginTop: 16,
          backgroundColor: colorAccent,
          borderRadius: 16,
        }}
      >
        <RowComponent
          style={{
            padding: 16,
            color: colorTextInverse,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <Typography.Text
            style={{
              color: "inherit",
              fontSize: 20,
              flex: "1 1 100%",
            }}
            strong
          >
            {useCase?.successStories == null
              ? "N/A"
              : useCase.successStories[0]?.metric}
          </Typography.Text>
          <Typography.Text
            style={{
              color: "inherit",
              fontWeight: 0,
              flex: "1 1 100%",
            }}
          >
            {useCase.successStories == null
              ? "Sin descripción"
              : useCase.successStories[0]?.description}
          </Typography.Text>
        </RowComponent>
      </ContainerComponent>
      <ContainerComponent
        style={{
          marginTop: 16,
          borderRadius: 16,
          backgroundColor: colorBgLayout,
        }}
      >
        <RowComponent
          style={{
            padding: 16,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <Typography.Text
            style={{
              color: colorTextHeading,
              fontSize: 20,
              flex: "1 1 100%",
            }}
            strong
          >
            {useCase?.successStories == null
              ? "N/A"
              : useCase.successStories[1]?.metric}
          </Typography.Text>
          <Typography.Text
            style={{
              color: colorTextHeading,
              fontWeight: 0,
              flex: "1 1 100%",
            }}
          >
            {useCase.successStories == null
              ? "Sin descripción"
              : useCase.successStories[1]?.description}
          </Typography.Text>
        </RowComponent>
      </ContainerComponent>
    </ColumnComponent>
  );
};
